<template>
	<v-container grid-list-md>
		<v-card>
			<v-card-title primary-title>
				<v-btn @click="
					$inertia.visit($route('central.subscriptions.index'))
					" rounded color="primary" dark small>
					<v-icon left>mdi-arrow-left</v-icon> {{ $t("Back") }}
				</v-btn>
				<v-spacer></v-spacer>
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text>
				<v-layout row wrap>
					<v-flex md12>
						<img :src="subscription.image_url" />
					</v-flex>
					<v-flex xs12 md12>
						<v-layout row wrap>
							<v-flex xs2 md2>
								<v-list-item-title class="float-right mt-3">
									{{ $t("Customer Name") }}
								</v-list-item-title>
							</v-flex>
							<v-flex xs4 md4>
								<v-list-item-title class="mt-3 pl-5 font-weight-black">
									{{ subscription.customer_name }}
								</v-list-item-title>
							</v-flex>
							<v-flex xs2 md2>
								<v-list-item-title class="float-right mt-3">
									{{ $t("Membership Name") }}
								</v-list-item-title>
							</v-flex>
							<v-flex xs4 md4>
								<v-list-item-title class="mt-3 pl-5 font-weight-black">
									{{ subscription.membership_name }}
								</v-list-item-title>
							</v-flex>
							<v-flex xs2 md2>
								<v-list-item-title class="float-right mt-3">
									{{ $t("Type") }}:
								</v-list-item-title>
							</v-flex>
							<v-flex xs4 md4>
								<v-list-item-title class="mt-3 pl-5 font-weight-black">
									{{ subscription.type }}
								</v-list-item-title>
							</v-flex>
							<v-flex xs2 md2>
								<v-list-item-title class="float-right mt-3">
									{{ $t("Payment Method") }}:
								</v-list-item-title>
							</v-flex>
							<v-flex xs4 md4>
								<v-list-item-title class="mt-3 pl-5 font-weight-black">
									{{ subscription.payment_method_code }}
								</v-list-item-title>
							</v-flex>
							<v-flex xs2 md2>
								<v-list-item-title class="float-right mt-3">
									{{ $t("Payment Status") }}:
								</v-list-item-title>
							</v-flex>
							<v-flex xs4 md4>
								<v-list-item-title class="mt-3 pl-5 font-weight-black">
									{{ subscription.payment_status }}
								</v-list-item-title>
							</v-flex>
							<v-flex xs2 md2>
								<v-list-item-title class="float-right mt-3">
									{{ $t("Start Date") }}:
								</v-list-item-title>
							</v-flex>
							<v-flex xs4 md4>
								<v-list-item-title class="mt-3 pl-5 font-weight-black">
									{{ subscription.formatted_start_date }}
								</v-list-item-title>
							</v-flex>
							<v-flex xs2 md2>
								<v-list-item-title class="float-right mt-3">
									{{ $t("End Date") }}:
								</v-list-item-title>
							</v-flex>
							<v-flex xs4 md4>
								<v-list-item-title class="mt-3 pl-5 font-weight-black">
									{{ subscription.formatted_end_date }}
								</v-list-item-title>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
	export default {
		props: ["subscription"],
	};
</script>